










































































































































































































































































































import { BaseUser } from '../../../services/shared/auth';
import BaseComponent from '../../../core/base.component';
import { Component } from 'vue-property-decorator';
import { CompanyUserListDto, CompanyUserDto, CompanyDto } from '../../../dto';
import { Pagination } from '../../../common';
import CompanyUserService from '../../../services/company-user.service';
import CompanyService from '../../../services/company.service';
import {
  CONST_APPROVAL_STATUS,
  APPROVAL_STATUS,
  COMPANY_USER,
  CONST_COMPANY_USER,
} from '../../../services/shared';

import { getStatusColor } from '../../../core/utils/status-color.util';
import toast from '../../../../resources/assets/js/services/toast.js';
import {
  ClearOutQueryParamMapper,
  ReverseQueryParamMapper,
  RouterQueryParamMapper,
} from '@/core';

@Component({
  name: 'CompanyUserList',
})
export default class CompanyUserList extends BaseComponent {
  private companyUserSearchDto = new CompanyUserListDto();
  private companyUserList: CompanyUserDto[] = Array<CompanyUserDto>();
  private companyUserTotalCount = null;
  private companySelect: CompanyDto[] = [];
  private availableCompanySelect: CompanyDto[] = [];
  private companyUserCreateDto = new CompanyUserDto(BaseUser);
  private pagination = new Pagination();
  private approvalStatus: APPROVAL_STATUS[] = [...CONST_APPROVAL_STATUS];
  private companyUserAdminRole: COMPANY_USER[] = [...CONST_COMPANY_USER];
  private dataLoading = false;

  // get status color
  getStatusColor(status: APPROVAL_STATUS) {
    return getStatusColor(status);
  }

  // TODO: Create autocomplete box
  getCompanies() {
    CompanyService.findAllForSelect().subscribe(res => {
      this.companySelect = res.data;
    });
  }

  getAvailableCompanies() {
    CompanyService.findForSelect().subscribe(res => {
      this.availableCompanySelect = res.data;
    });
  }

  paginateSearch() {
    this.findAll(true);
  }

  search() {
    this.findAll(true, true);
  }

  clearOut() {
    if (location.search) {
      ClearOutQueryParamMapper();
    } else {
      this.companyUserSearchDto = new CompanyUserListDto();
      this.findAll();
    }
  }

  clearOutCompanyUserDto() {
    this.companyUserCreateDto = new CompanyUserDto(BaseUser);
  }

  findAll(isPagination?: boolean, isSearch?: boolean) {
    this.dataLoading = true;
    if (!isPagination) {
      this.pagination.page = 1;
    } else {
      if (isSearch) this.pagination.page = 1;
      RouterQueryParamMapper(this.companyUserSearchDto, this.pagination);
    }
    CompanyUserService.findAll(
      this.companyUserSearchDto,
      this.pagination,
    ).subscribe(res => {
      if (res) {
        this.dataLoading = false;
        this.companyUserList = res.data.items;
        this.companyUserTotalCount = res.data.totalCount;
      }
    });
  }

  // 사용자 생성
  createCompanyUser() {
    CompanyUserService.createCompanyUser(this.companyUserCreateDto).subscribe(
      res => {
        if (res) {
          toast.success('추가완료');
          this.clearOut();
        }
      },
    );
  }

  created() {
    const query = ReverseQueryParamMapper(location.search);
    if (query) {
      this.companyUserSearchDto = query;
      if (!isNaN(+query.limit) && !isNaN(+query.page)) {
        this.pagination.limit = +query.limit;
        this.pagination.page = +query.page;
      } else {
        this.pagination = new Pagination();
      }
      this.paginateSearch();
    } else {
      this.findAll();
    }
    this.getCompanies();
    this.getAvailableCompanies();
  }
}
